import { createSearchSDK } from '@/assets/js/shared/services/search-sdk';

/**
 * This plugin is used to inject the Trazi Search SDK into the client context.
 *
 * @param {Object} _ctx - The context object.
 * @param {Function} inject - The inject function.
 * @returns {void}
 */
export default (_ctx, inject) => {
  inject(
    'searchSDK',
    createSearchSDK({ baseUrl: `${window.location.origin}/api` })
  );
};
